import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import { Heading, ListingCard } from '../../components';

import css from './SectionDesignMaterialsMaybe.module.css';

/**
 * Matterax design showcase: "Materials in this project" section.
 * Renders the catalog listings tagged on a design (publicData.designProducts)
 * as regular listing cards, each linking to the product's listing page.
 * Notes ("Used for: kitchen island") come from the tag data itself.
 *
 * Renders nothing for non-design listings or while product data hasn't loaded.
 */
const SectionDesignMaterialsMaybe = props => {
  const { publicData, designProductListings } = props;

  const isDesign = publicData?.listingType === 'design-showcase';
  const designProducts = Array.isArray(publicData?.designProducts) ? publicData.designProducts : [];
  const listings = designProductListings || [];

  if (!isDesign || designProducts.length === 0 || listings.length === 0) {
    return null;
  }

  const noteById = designProducts.reduce(
    (acc, p) => (p?.id ? { ...acc, [p.id]: p.note } : acc),
    {}
  );

  return (
    <section className={css.root}>
      <Heading as="h2" rootClassName={css.title}>
        <FormattedMessage
          id="ListingPage.designMaterialsTitle"
          values={{ count: listings.length }}
        />
      </Heading>
      <p className={css.subtitle}>
        <FormattedMessage id="ListingPage.designMaterialsSubtitle" />
      </p>
      <div className={css.grid}>
        {listings.map(l => {
          const note = noteById[l.id.uuid];
          return (
            <div key={l.id.uuid} className={css.cardWrapper}>
              <ListingCard listing={l} />
              {note ? (
                <p className={css.note}>
                  <FormattedMessage id="ListingPage.designMaterialNote" values={{ note }} />
                </p>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SectionDesignMaterialsMaybe;
